
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Alert from '~/components/Alerts/Alert.vue';
import BankDetails from '@/components/BankAccountSetup/BankDetails.vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import DepositsTable from '@/components/common/DepositsTable.vue';
import VerifyDepositsAmount from '@/components/BankAccountSetup/VerifyDepositsAmount.vue';
import { PaymentProviderBankDetails, VerificationStatuses } from '@/interfaces/bank-account';
import { reinitiateMicroDeposits } from '@/api/account';
import AchProvidersMixin from '@/mixins/AchProvidersMixin';

@Component({
  components: {
    Alert,
    BankDetails,
    CustomButton,
    DepositsTable,
    VerifyDepositsAmount
  }
})
export default class BankAccountSetup extends mixins(AchProvidersMixin) {
  step = 0;

  accountLocked = false;

  verificationFailed = false;

  hideBankAccountInputs = false;

  exceededLimit = false;

  loading = false;

  showInterstitial = false;

  lastFour = '';

  get supportEmail() {
    return this.$store.getters['Config/getBrandSupportEmail'];
  }

  get supportPhone() {
    return this.$store.getters['Config/getBrandSupportPhone'];
  }

  get bankDetails(): PaymentProviderBankDetails | null {
    return this.$store.getters['PaymentOptions/getBankAccount'];
  }

  get bankLastFour() {
    return this.bankDetails?.bank_account_last_4 || this.lastFour || '';
  }

  async created() {
    switch (this.bankDetails?.bank_status) {
      case VerificationStatuses.NEW:
        this.step = 1;
        this.hideBankAccountInputs = true;
        break;

      case VerificationStatuses.PENDING:
        this.step = 2;
        break;

      case VerificationStatuses.VERIFICATION_FAILED:
        this.verificationFailed = true;
        this.step = 1;
        break;

      case VerificationStatuses.ERRORED:
        this.accountLocked = true;
        break;

      default:
        this.step = 1;
        break;
    }
  }

  onBankDetailsSuccess(lastFour?: string) {
    if (this.isAchProviderCrb) {
      this.$emit('success', lastFour);
      return;
    }

    this.showInterstitialScreen(lastFour);
  }

  private showInterstitialScreen(lastFour?: string) {
    this.verificationFailed = false;
    this.showInterstitial = true;
    this.lastFour = lastFour ?? '';
  }

  setExceededLimit() {
    this.exceededLimit = true;
  }

  async sendDeposits() {
    this.loading = true;
    try {
      await reinitiateMicroDeposits();
      this.showInterstitialScreen();
    } catch {
      this.$router.push({ name: 'error' });
    } finally {
      this.loading = false;
    }
  }
}
